import Contacts from '@/features/contacts';
import { listContactsQuery } from '@/queries/contact.query';
import { listTagsQuery } from '@/queries/tags.query';
import { ContactFilters } from '@/types/filters/contact';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/_authenticated/contacts/')({
  component: Contacts,
  head: () => ({
    meta: [{
      title: 'Contacts | Wazai',
    }]
  }),
  loader: async ({ context }) => {
    await context.queryClient.ensureQueryData(listContactsQuery());
    await context.queryClient.ensureQueryData(listTagsQuery);
  },
  validateSearch: () => ({}) as ContactFilters,
})
